import Image from 'next/image';
import { AiFillCaretRight } from 'react-icons/ai';
import Link from 'next/link';
import { getImgUrl } from '@utils/functions/getImgUrl';
import ViewsAndReadTime from './ViewsAndReadTime';
import PublishedDate from './PublishedDate';
import Tag from './Tag';
import AuthorDetails from './AuthorDetails';
import { HiArrowUpRight } from 'react-icons/hi2';

const ArticleCard = ({
  heroImage,
  title,
  author = { data: { attributes: {} } },
  views,
  tags,
  topRead,
  slug,
}) => {
  const { name, thumbnail, publishedAt } = author.data.attributes;
  const href = `/bytes/articles/${slug}`;
  return (
    <Link href={href} as={href} passHref>
      <a className="flex flex-col items-center">
        <div className="cursor-pointer">
          <Image
            src={getImgUrl(heroImage)}
            height={300}
            width={500}
            objectFit="fill"
            alt={heroImage?.data?.attributes?.name ?? 'img'}
            style={{ borderRadius: '16px' }}
          />
        </div>
        <div className="flex h-full flex-col items-start gap-y-[16px] pt-2 font-satoshi-regular">
          <div className="flex items-center gap-x-2">
            {(tags?.data ?? tags)?.slice(0, 2).map((item) => (
              <span
                key={item?.attributes?.name ?? item?.name}
                className="font-satoshi-medium text-[14px] font-semibold leading-5 text-[#D80E32]"
              >
                {item?.attributes?.name ?? item?.name}
              </span>
            ))}
          </div>
          <p className="grid grid-cols-12 gap-x-2 text-[24px] leading-8">
            <span className="col-span-11 font-satoshi-bold font-bold  line-clamp-2">{title}</span>
            <HiArrowUpRight />
          </p>
          <AuthorDetails
            name={name}
            postedAt={publishedAt}
            avatarImage={thumbnail}
            className={'mt-auto'}
          />
        </div>
      </a>
    </Link>
  );
};

export default ArticleCard;
